import { createFileRoute } from '@tanstack/react-router';

import { PlacementsTable } from '../features/supply/placements/components/PlacementsTable';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/placements')({
  component: PublisherPlacementsRoute,
});

function PublisherPlacementsRoute() {
  const { publisherId } = Route.useParams();
  return <PlacementsTable publisherId={publisherId} />;
}
